angular
    .module('MyApp')
    .service('PagamentosService', ['$resource', '$q', 'SessionData', 'Configs', function($resource, $q, SessionData, Configs) {


      this.listarPagamentos = function(codPessoa, id_projeto){
        let deferr = $q.defer();
         if (codPessoa && id_projeto) {
            $resource(Configs.getApiServer() + '/edital/pagamentos?cod-pessoa=:codPessoa&id-projeto=:id_projeto',
                {}, { 'query': { method: 'GET', isArray: true } }).query({
                  codPessoa, id_projeto
                }, function (response) {
                  deferr.resolve(response);

                }, function(){
                    deferr.reject();
                });
        } else {
            deferr.resolve(false);
        }
        return deferr.promise;
      }

    }]);
